declare namespace $ {

	type $mol_view__sub_shm_ba_file_store_list_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_file_store_list_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_shm_ba_file_store_list_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_major__title_shm_ba_file_store_list_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_ba_file_store_list_5 = $mol_type_enforce<
		ReturnType< $shm_ba_file_store_list['delete_all'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_shm_ba_file_store_list_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_ba_file_store_list_7 = $mol_type_enforce<
		ReturnType< $shm_ba_file_store_list['delete_all_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_ba_file_store_list_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_file_store_list_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__align_shm_ba_file_store_list_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__showed_shm_ba_file_store_list_11 = $mol_type_enforce<
		ReturnType< $shm_ba_file_store_list['delete_all_showed'] >
		,
		ReturnType< $mol_pick['showed'] >
	>
	type $mol_pick__auto_shm_ba_file_store_list_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['auto'] >
	>
	type $mol_pick__trigger_content_shm_ba_file_store_list_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_ba_file_store_list_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_view__sub_shm_ba_file_store_list_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__hint_shm_ba_file_store_list_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_ba_file_store_list_17 = $mol_type_enforce<
		ReturnType< $shm_ba_file_store_list['search'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_list__rows_shm_ba_file_store_list_18 = $mol_type_enforce<
		ReturnType< $shm_ba_file_store_list['file_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_ba_file_store_list_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_file_store_list_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_file_store_list_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_file_store_list_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_ba_file_store_list_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_ba_file_store_list_24 = $mol_type_enforce<
		ReturnType< $shm_ba_file_store_list['file_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_ba_file_store_list_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_ba_file_store_list_26 = $mol_type_enforce<
		ReturnType< $shm_ba_file_store_list['file_delete_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_ba_file_store_list_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__align_shm_ba_file_store_list_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__showed_shm_ba_file_store_list_29 = $mol_type_enforce<
		ReturnType< $shm_ba_file_store_list['file_delete_showed'] >
		,
		ReturnType< $mol_pick['showed'] >
	>
	type $mol_pick__auto_shm_ba_file_store_list_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['auto'] >
	>
	type $mol_pick__trigger_content_shm_ba_file_store_list_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_ba_file_store_list_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_view__sub_shm_ba_file_store_list_33 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_file_store_list_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_ba_file_store_list extends $mol_view {
		Title( ): $mol_view
		files_summary( ): string
		Summary( ): $mol_view
		delete_all_showed( next?: boolean ): boolean
		delete_all_outside_listener( ): any
		Delete_all_icon( ): $mol_icon_trash_can
		Delete_all_text( ): $mol_paragraph
		delete_all( next?: any ): any
		Delete_all_yes( ): $mol_button_major
		delete_all_cancel( next?: any ): any
		Delete_all_no( ): $mol_button_minor
		Delete_all_actions( ): $mol_view
		Delete_all_confirm( ): $mol_view
		Delete_all( ): $mol_pick
		Head( ): $mol_view
		search( next?: string ): string
		Search( ): $mol_string
		file_rows( ): readonly(any)[]
		Files( ): $mol_list
		file_title( id: any): string
		File_title( id: any): $mol_view
		file_meta( id: any): string
		File_meta( id: any): $mol_view
		File_info( id: any): $mol_view
		file_delete_showed( id: any, next?: boolean ): boolean
		file_delete_outside_listener( id: any): any
		File_delete_icon( id: any): $mol_icon_trash_can
		File_delete_text( id: any): $mol_view
		file_delete( id: any, next?: any ): any
		File_delete_yes( id: any): $mol_button_minor
		file_delete_cancel( id: any, next?: any ): any
		File_delete_no( id: any): $mol_button_minor
		File_delete_bubble( id: any): $mol_view
		File_delete( id: any): $mol_pick
		empty_message( ): string
		sub( ): readonly(any)[]
		File_row( id: any): $mol_view
		Empty( ): $mol_view
	}
	
}

//# sourceMappingURL=list.view.tree.d.ts.map